var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlPrint24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Control/Print24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconPrint",
    transform: "translate(2.000000, 4.000000)",
    fill: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L3,5 L0,5 L0,13.001 L3,13.001 L3,17 L17,17 L17,13.001 L20,13.001 L20,5 L17,5 L17,0 L3,0 Z M5.001,5.001 L15.001,5.001 L15.001,2 L5.001,2 L5.001,5.001 Z M2,7 L18,7 L18,11 L17,11 L17,9 L3,9 L3,11 L2,11 L2,7 Z M5.001,15.001 L15.001,15.001 L15.001,11 L5.001,11 L5.001,15.001 Z",
    id: "iconPrint24"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlPrint24);
export default __webpack_public_path__ + "static/media/controlPrint24.3bde7036fc81af7d6ab42f5c3ce1f204.svg";
export { ForwardRef as ReactComponent };